import { useCallback } from "react";
import type { ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks.ts";
import SelectFieldInput from "./SelectFieldInput.tsx";

interface Props {
  availableFields: ReportField[];
  disabled: boolean;
}

export const SelectGroupFieldInput = ({ availableFields, disabled }: Props) => {
  const dispatch = useAppDispatch();

  const addFieldToGroup = useCallback(
    (field: ReportField) => dispatch(fieldsStateActions.addGroup({ id: field.config.guid })),
    [dispatch]
  );

  return <SelectFieldInput onAddField={addFieldToGroup} availableFields={availableFields} disabled={disabled} />;
};

export default SelectGroupFieldInput;
